module.exports = {
	"id": "RS",
	"name": "Serbia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.028856,
			"12": 0.014428,
			"13": null,
			"14": 0.007214,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.028856,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.07214,
			"23": null,
			"24": null,
			"25": 0.014428,
			"26": 0.057712,
			"27": 0.007214,
			"28": null,
			"29": 0.021642,
			"30": 0.014428,
			"31": 0.050498,
			"32": 0.014428,
			"33": 0.03607,
			"34": 0.100996,
			"35": 0.014428,
			"36": 0.021642,
			"37": 0.03607,
			"38": 0.050498,
			"39": 0.079354,
			"40": 0.043284,
			"41": 0.021642,
			"42": 0.021642,
			"43": 0.10821,
			"44": 0.064926,
			"45": 0.03607,
			"46": 0.050498,
			"47": 0.129852,
			"48": 0.100996,
			"49": 4.631388,
			"50": 0.115424,
			"51": 0.46891,
			"52": 0.418412,
			"53": 30.818208,
			"54": 8.858792,
			"55": 0.187564,
			"56": 0.050498,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.021642,
			"4": 0.007214,
			"5": null,
			"6": null,
			"7": null,
			"8": 0.007214,
			"9": 0.007214,
			"10": 0.007214,
			"11": 0.007214,
			"12": 0.014428,
			"13": null,
			"14": null,
			"15": 0.014428,
			"16": 0.014428,
			"17": null,
			"18": 0.007214,
			"19": null,
			"20": 0.014428,
			"21": null,
			"22": 0.007214,
			"23": null,
			"24": 0.007214,
			"25": null,
			"26": 0.014428,
			"27": 0.007214,
			"28": 0.014428,
			"29": 0.021642,
			"30": 0.014428,
			"31": 0.028856,
			"32": 0.014428,
			"33": 0.028856,
			"34": 0.021642,
			"35": 0.03607,
			"36": 0.028856,
			"37": 0.043284,
			"38": 0.079354,
			"39": 0.057712,
			"40": 0.050498,
			"41": 0.07214,
			"42": 0.07214,
			"43": 0.223634,
			"44": 0.079354,
			"45": 0.165922,
			"46": 0.115424,
			"47": 0.764684,
			"48": 0.678116,
			"49": 11.79489,
			"50": 0.302988,
			"51": 0.014428,
			"52": null,
			"3.5": 0.007214,
			"3.6": 0.043284
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.007214,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.007214,
			"21": null,
			"22": 0.014428,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.014428,
			"27": null,
			"28": 0.007214,
			"29": 0.014428,
			"30": 0.014428,
			"31": 0.007214,
			"32": null,
			"33": null,
			"34": 0.007214,
			"35": 0.021642,
			"36": 0.230848,
			"37": 0.064926,
			"38": 0.050498,
			"39": 0.043284,
			"40": 2.113702,
			"41": 0.367914,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.014428,
			"12.1": 0.266918
		},
		"safari": {
			"0": null,
			"4": 0.007214,
			"5": null,
			"6": null,
			"7": 0.007214,
			"8": 0.03607,
			"9": 0.043284,
			"10": 0.353486,
			"3.1": null,
			"3.2": null,
			"5.1": 0.03607,
			"6.1": 0.014428,
			"7.1": 0.007214,
			"9.1": 0.158708
		},
		"ios_saf": {
			"8": 0,
			"10": 1.95020927893,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0525558834305,
			"8.1-8.4": 0.0970947676936,
			"9.0-9.2": 0.0463204396336,
			"9.3": 0.706683630308
		},
		"android": {
			"3": 0,
			"4": 0.0582540361757,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00728175452196,
			"4.1": 0.210130630491,
			"4.2-4.3": 0.525326576227,
			"4.4": 1.20461024806,
			"4.4.3-4.4.4": 1.21501275452
		},
		"ie": {
			"6": 0.0148167784431,
			"7": 0.00740838922156,
			"8": 0.355602682635,
			"9": 0.19261811976,
			"10": 0.118534227545,
			"11": 1.7854218024,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0703195542415,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00195332095115
		},
		"edge": {
			"12": 0.050498,
			"13": 0.209206,
			"14": 0.569906
		},
		"ie_mob": {
			"10": 0.190075830986,
			"11": 0.773880169014
		},
		"bb": {
			"7": 0.0104475,
			"10": null
		},
		"samsung": {
			"0": 1.593592
		},
		"and_uc": {
			"0": 0.122584
		},
		"op_mini": {
			"0": 0.947403124807
		},
		"and_chr": {
			"0": 19.283308
		},
		"and_ff": {
			"0": 0.01393
		}
	},
	"total": 98.0468135
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/RS.json
 ** module id = 634
 ** module chunks = 0
 **/